import React, { useState } from "react";
import Button from "../../atoms/Button";
import Registries from "./Registry";
import Tokens from "./Tokens";
import TransactionType from "./Transaction";
import CreditType from "./Credit";
import Category from "./Category";
import MultiRangeSlider from "./Slider";
import SdgContribution from "./Sdg";
import DiaglogBox from "../../atoms/DiaglogBox";
import ProjectVintage from "./ProjectVintage";
import CountrySelect from "./Country";
import Type from "./Type";
import UserType from "./UserType";

const FilterDialogBox = ({
  open,
  onOk,
  onCancel,
  showProject,
  selectedRegistry,
  setSelectedRegistry,
  onCheckRegistry,
  selectedCategory,
  onSelectCategory,
  selectedProjectVintage,
  onSelectProjectVintage,
  selectedToken,
  onChangeToken,
  selectedCreditType,
  onSelectCreditType,
  selectedTypeOfTransaction,
  onSelectTypeOfTransaction,
  selectedCountry,
  onSelectCountry,
  selectedType,
  onCheckType,
  selectedUserType,
  onCheckUserType,
  min, // This is lowPrice passed from the parent component
  max, // This is highPrice passed from the parent component
  setLowPrice, // This is the function to set lowPrice in the parent component
  setHighPrice,
}) => {
  const [minTransaction, setMinTransaction] = useState("");

  const handleMinTransactionChange = (e) => {
    setMinTransaction(e.target.value);
  };

  return (
    <>
      <div>
        <DiaglogBox open={open} onCancel={onCancel} width={617}>
          <div className="max-h-96 overflow-hidden overflow-y-scroll px-6 no-scrollbar">
            <h1 className="text-[1.75rem] ml-3 pb-2 font-bold text-black">
              Filter
            </h1>
            <hr />
            {showProject ? (
              <>
                <h1 className="py-2 ml-3 text-xs font-normal text-grey-700">
                  Registries
                </h1>
                <Registries
                  selectedRegistry={selectedRegistry}
                  setSelectedRegistry={setSelectedRegistry}
                  onCheckRegistry={onCheckRegistry}
                />
                <hr />
                <div className="flex">
                  <div className="flex w-1/2 flex-col">
                    <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                      Category
                    </h2>
                    <Category
                      selectedCategory={selectedCategory}
                      onSelectCategory={onSelectCategory}
                    />
                  </div>
                  <div className="flex w-1/2 flex-col">
                    <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                      ProjectVintage
                    </h2>
                    <ProjectVintage
                      selectedProjectVintage={selectedProjectVintage}
                      onSelectProjectVintage={onSelectProjectVintage}
                    />
                  </div>
                </div>
                <hr />
                <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                  Types of tokens
                </h2>
                <Tokens
                  selectedToken={selectedToken}
                  onChangeToken={onChangeToken}
                />
                <hr />
                <div className="mb-4">
                  <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                    Price
                  </h2>
                  <MultiRangeSlider
                    min={0}
                    max={50}
                    onChange={({ min, max }) => {
                      setLowPrice(min);
                      setHighPrice(max);
                    }}
                    filter="projects"
                  />
                </div>
                <hr />
                <div className="flex ml-3 py-2 ">
                  <div className=" pr-4 border-r-2 border-grey-400">
                    <h2 className=" text-xs font-normal  text-gray-400">
                      Types of transaction
                    </h2>
                    <TransactionType
                      selectedTypeOfTransaction={selectedTypeOfTransaction}
                      onSelectTypeOfTransaction={onSelectTypeOfTransaction}
                    />
                  </div>

                  <div className="pl-8">
                    <h2 className=" text-xs font-normal text-grey-700">
                      Credit type
                    </h2>
                    <CreditType
                      selectedCreditType={selectedCreditType}
                      onSelectCreditType={onSelectCreditType}
                    />
                  </div>
                </div>
                <hr />
                <div>
                  <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                    Country
                  </h2>
                  <CountrySelect
                    selectedCountry={selectedCountry}
                    onSelectCountry={onSelectCountry}
                  />
                </div>
                <hr />
                <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                  SDGs focused
                  <SdgContribution />
                </h2>
                <hr />
              </>
            ) : (
              <>
                <div className="flex pt-2 ml-3 mb-1">
                  <div>
                    <h2 className="pb-4 text-xs font-normal text-grey-700">
                      Type
                    </h2>
                    <Type
                      selectedType={selectedType}
                      onCheckType={onCheckType}
                    />
                  </div>
                  <div className="ml-4">
                    <h2 className="pb-4 text-xs font-normal text-grey-700">
                      Users
                    </h2>
                    <UserType
                      selectedUserType={selectedUserType}
                      onCheckUserType={onCheckUserType}
                    />
                  </div>
                </div>
                <hr />
                <div>
                  <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                    Location
                  </h2>
                  <CountrySelect />
                </div>
                <hr />
                <div className="mb-4">
                  <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                    Authenticity
                  </h2>
                  <MultiRangeSlider
                    min={0}
                    max={100}
                    onChange={({ min, max }) => {}}
                    filter="user"
                  />
                </div>
                <hr />
                <div className="mb-4 pb-4">
                  <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                    Minimum Transaction
                  </h2>
                  <input
                    type="text"
                    value={minTransaction}
                    onChange={handleMinTransactionChange}
                    className="w-1/4 py-2 px-4 ml-2 rounded-lg border border-grey-800 focus:outline-none "
                  />
                </div>
              </>
            )}
            <div className="flex mb-4 mt-4 ">
              <Button
                varient="primary"
                borderColor="black"
                color="blue"
                className="w-1/2 text-sm justify-center mr-4 px-6 py-2 text-white font-bold"
                onClick={onOk}
              >
                Submit
              </Button>
              <Button
                varient="primary"
                className="w-1/2 text-sm justify-center px-6 py-2 text-blue-800 bg-blue-250 font-bold"
                onClick={onCancel}
              >
                Cancel
              </Button>
            </div>
          </div>
        </DiaglogBox>
      </div>
    </>
  );
};

export default FilterDialogBox;
